import Button from "@/components/Button";

const SignUpCTAButton = () => {
  return (
    <Button
      theme="violet"
      href="/onboarding"
      className="max-xs:h-component-sm lg:h-component-lg w-fit px-6 max-xs:px-4 max-xs:text-xs lg:px-8"
      label="Start Your Free Trial"
    />
  );
};

export default SignUpCTAButton;
